/**
 * Kickoff som UTC-instant (samma kontrakt som backend/kickoff_time.py).
 * ISO utan tidszon behandlas som UTC — inte webbläsarens lokala tid.
 */
export function parseKickoffUtcMs(raw) {
  if (raw == null || raw === "") return null;
  let s = String(raw).trim();
  const hasTz =
    s.endsWith("Z") ||
    s.endsWith("z") ||
    /[+-]\d{2}:\d{2}$/.test(s) ||
    /[+-]\d{4}$/.test(s);
  if (!hasTz && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(s)) {
    s = `${s}:00Z`;
  } else if (!hasTz && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(s)) {
    s = `${s}Z`;
  }
  const t = Date.parse(s);
  return Number.isFinite(t) ? t : null;
}

/** Date för visning i svensk/lokal tid (kickoff är UTC-instant). */
export function kickoffToDate(raw) {
  const ms = parseKickoffUtcMs(raw);
  return ms == null ? new Date(NaN) : new Date(ms);
}
